import { render, staticRenderFns } from "./MainCard.vue?vue&type=template&id=256891f6&scoped=true"
import script from "./MainCard.vue?vue&type=script&lang=js"
export * from "./MainCard.vue?vue&type=script&lang=js"
import style0 from "./MainCard.vue?vue&type=style&index=0&id=256891f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256891f6",
  null
  
)

export default component.exports